import { Box, CircularProgress, Typography } from "@mui/material";
import React from "react";

const IsLoading = ({ message = "Loading..." }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100vh"
    >
      <CircularProgress color="primary" size={60} />
      <Typography
        variant="subtitle1"
        color="textSecondary"
        style={{ marginTop: 10 }}
      >
        {message}
      </Typography>
    </Box>
  );
};

export default IsLoading;
